export const labels: any = {
  title: { en: 'Noise Diagnosis Portal', ko: '소음진단포털' },
  search: { en: 'Search', ko: '찾다' },
  entries_type: { en: 'Entries Type', ko: '항목 유형' },
  current_time: { en: 'Current Time', ko: '현재 시간' },
  days_left: { en: 'Days Left', ko: '남은 일수' },
  deadline: { en: 'Deadline', ko: '마감 시간' },
  remaining_time: { en: 'Remaining Time', ko: '남은 시간' },
  received_date: { en: 'Received Date', ko: '받은 날짜' },
  file_id: { en: 'File ID', ko: '파일 ID' },
  audio: { en: 'Recorded Files', ko: '녹음 파일' },
  serialno: { en: 'Serial Number', ko: '시리얼 넘버' },
  identification: { en: 'Identification', ko: '분류' },
  model_code: { en: 'Model Code', ko: '모델 코드' },
  description: { en: 'Description', ko: '고객 설명' },
  source: { en: 'Source', ko: '소스' },
  noise_type_main: { en: 'Noise Type (Main)', ko: '소음유형(대분류)' },
  noise_type_sub: { en: 'Noise Type (Sub)', ko: '소음유형(소분류)' },
  notification: { en: 'Notification', ko: '공고' },
  customer_notification: { en: 'Customer Notification', ko: '고객 알림' },
  service_notification: { en: 'Service Notification', ko: '서비스 알림' },
  classification_accuracy: {
    en: 'Classification Reliability',
    ko: '분류 신뢰도',
  },
  analysis_result: { en: 'Signal Analysis Result', ko: '신호 분석 결과' },
  serviceResult: { en: 'Service Result', ko: '서비스 결과' },
  serviceNoResult: { en: 'No Records', ko: '노 레코드' },
  seq_no: { en: 'Service Number', ko: '접수 번호' },
  org_repa_name: { en: 'Processing Name', ko: '처리명' },
  repa_dat: { en: 'Repair Info', ko: '처리내용(수리내역)' },
  con_date: { en: 'Repair Date', ko: '수리 일자' },
  details: { en: 'Details', ko: '상세 내용' },
  ai: { en: 'AI result', ko: '인공 지능' },
  privacyNotice: {
    en: `The noise diagnosis portal is subject to security management because it contains the customer's personal information.\nFiles downloaded from the noise diagnosis portal should never be shared with others or stored on a personal PC.\nPlease delete the file downloaded from the noise diagnosis portal after the analysis is completed.`,
    ko: `소음 진단 포털은 고객의 개인정보를 포함하고 있으므로 보안 관리 대상입니다.\n소음 진단 포털에서 다운로드 하신 파일은 절대로 타인에게 공유하거나 개인 PC에 보관하시면 안됩니다.\n소음 진단 포털에서 다운로드 하신 파일은 분석 완료 후 반드시 삭제 부탁드립니다. `,
  },
  securityPledges :
        {
          ko: ['소음 진단 포털은 고객의 개인정보를 포함하고 있으므로 보안 관리 대상입니다.',
            '당사 시스템 내 데이터를 업무 외 목적으로 열람 및 PC 내 저장하지 않도록 합니다.',
            '업무상 불가피하게 데이터를 다운받아 저장이 필요한 경우, 목적이 종료되면 즉시 파일을 삭제하도록 합니다.',
            '소음 진단 포털에서 다운로드 하신 파일은 절대로 타인에게 공유하거나 개인 PC에 보관하시면 안됩니다.',
          ],
          en: ['The noise diagnosis portal is subject to security management because it contains the customer\'s personal information.',
            'Do not view or store data within our system for non-business purposes on PC.',
            'If it is necessary to download and save data due to unavoidable work, delete the file immediately when the purpose is over.',
            'Please delete the file downloaded from the noise diagnosis portal after the analysis is completed.'
          ]
        },
  agreementStatement:{
    ko:"위 유의사항에 대해서 성실히 이행하겠습니다.",
    en:"I will faithfully carry out the above precautions."
  }
};
